import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Component from './Component';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoadingSubscribed,
    errorSubscribed,
    subscribedMessage,
    subscribed,
  } = state.master;
  return {
    isLoadingSubscribed,
    errorSubscribed,
    subscribedMessage,
    subscribed,
  };
}

const Styled = withStyles(styles)(Component);

export default connect(
  mapStateToProps,
)(Styled);
